import {setPdfView} from "./utils";

const axios = require('axios');
import EventBus from '../api/event-bus.js';
import {errorHandler} from "./common";


export function getManifest(id) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/manifest?id=' + id,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      EventBus.$emit("showLoading", false);
      errorHandler(err);
      reject(err);
    })
  })
}
export function getManifestRequestCandidates() {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.ROOT_API + 'admin/requests/unassigned',  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      errorHandler(err);
      reject(err);
    })
  })
}
export function getAvailableManifests(stateFrom, stateTo) {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.ROOT_API + 'admin/manifests/states?stateFrom=' + stateFrom + '&stateTo='+stateTo,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      errorHandler(err);
      reject(err);
    })
  })
}
export function getManifests(dateFrom, dateTo) {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.ROOT_API + 'admin/manifests?dateFrom=' + dateFrom + "&dateTo="+dateTo,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      errorHandler(err);
      reject(err);
    })
  })
}
export function printMawb(id) {
  return new Promise(function (resolve, reject) {
    console.log("get Item ")
    EventBus.$emit("showLoading", true);
    let axiosConfig = {
      method: 'get',
      responseType: 'blob',
      url: process.env.ROOT_API + 'admin/manifest/mawb?id=' + id,
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    };
    axios(axiosConfig).then(function (response) {
      EventBus.$emit("showLoading", false);
      // let data = response['data'];
      // console.log("get Items");
      // console.log(data);
      setPdfView(response.data);
      resolve(response);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
export function printHawb(id) {
  return new Promise(function (resolve, reject) {
    console.log("get Item ")
    EventBus.$emit("showLoading", true);
    let axiosConfig = {
      method: 'get',
      responseType: 'blob',
      url: process.env.ROOT_API + 'admin/manifest/hawb?id=' + id,
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    };
    axios(axiosConfig).then(function (response) {
      EventBus.$emit("showLoading", false);
      // let data = response['data'];
      // console.log("get Items");
      // console.log(data);
      setPdfView(response.data);
      resolve(response);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        errorHandler(error);
        reject(error)
      });
  })
}
function manifestErrorMessage(err, fallback) {
  const res = err && err.response;
  if (res && res.data) {
    if (typeof res.data === 'string' && res.data.length > 0) {
      return res.data;
    }
    if (res.data.message) {
      return res.data.message;
    }
  }
  if (err && err.message) {
    return err.message;
  }
  return fallback || 'Failed to save manifest.';
}

export function updateManifest(manifest) {
  return new Promise(function(resolve, reject) {
    const requestCount = manifest && manifest.requests ? manifest.requests.length : 0;
    const payload = JSON.stringify(manifest);
    console.log('[updateManifest] POST admin/manifest', {
      id: manifest && manifest.id,
      bkNo: manifest && manifest.bkNo,
      shippingMode: manifest && manifest.shippingMode,
      state: manifest && manifest.state,
      cbm: manifest && manifest.cbm,
      kg: manifest && manifest.kg,
      qty: manifest && manifest.qty,
      requestCount: requestCount,
      requestIds: manifest && manifest.requests
        ? manifest.requests.map(function (r) { return r && r.id; })
        : [],
      payloadBytes: payload ? payload.length : 0
    });
    axios.post(process.env.ROOT_API + 'admin/manifest', payload,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      let data = response.data;
      console.log('[updateManifest] OK', {
        success: data && data.success,
        message: data && data.message,
        savedId: data && data.item && data.item.id
      });
      resolve(data);
    }).catch(function(err) {
      const res = err && err.response;
      const userMessage = manifestErrorMessage(err, 'Failed to save manifest.');
      console.error('[updateManifest] FAILED', {
        status: res && res.status,
        statusText: res && res.statusText,
        data: res && res.data,
        message: userMessage,
        manifestId: manifest && manifest.id,
        requestCount: requestCount
      });
      errorHandler(err);
      const wrapped = new Error(userMessage);
      wrapped.response = res;
      wrapped.original = err;
      reject(wrapped);
    })
  })
}
export function deleteManifest(id) {
  return new Promise(function(resolve, reject) {
    axios.delete(process.env.ROOT_API + 'admin/manifest?id=' + id,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      errorHandler(err);
      reject(err);
    })
  })
}
export function getShippingAdvicePDF(id) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/manifest/shippingAdvice/pdf?id=' + id, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response.data;
      resolve(data);
    }).catch(function (err) {
      EventBus.$emit("showLoading", false);
      errorHandler(err);
      reject(err);
    })
  })
}
export function getBlInstructionPDF(id) {
  EventBus.$emit("showLoading", true);
  return new Promise(function(resolve, reject) {
    axios.get(process.env.ROOT_API + 'admin/manifest/blinstruction/pdf?id=' + id, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response.data;
      resolve(data);
    }).catch(function (err) {
      EventBus.$emit("showLoading", false);
      errorHandler(err);
      reject(err);
    })
  })
}
export function createNewManifest() {
  let item = {
    id:0,
    shippingMode:'',
    awb:'',
    awb1:'',
    awb2:'',
    awb3:'',
    cbm:0,
    cbmFloat:0.0,
    etd:'',
    eta:'',
    mblNo:'',
    containerNumber:'',
    sealNumber:'',
    containerSize:'',
    qty:0,
    kg:0,
    dcDo:0,
    dcStr:0,
    dcIns:0,
    dcLift:0,
    dcDelivery:0,
    dcFullSet:0,
    cr:0,
    dr:0,
    bkNo:'',
    remarks:"",
    requests:[],
    vessel:'',
    portOfLoading:'SOUTHAMPTON, UK',
    portOfDischarge: 'BUSAN, KOREA',
    shipper:'UKO SHIPPING',
    shipperAddress:'UNIT 7 CAKER STREAM ROAD\nALTON\nENGLAND\nGU34 2QA',
    shipperAddress2:'',
    shipperAddress3:'',
    shipperTel:'',
    consigneeId:0,
    consignee:'OKSHIPPING',
    consigneeAddress:'26 BUNGIL, 61 GANGCHON RO\nILSAN DONGGU, GOYANGSI, KYOUNGGI DO, KOREA\nTEL: 02 333 2422 Email: kang395600@naver.com',
    notifyId:0,
    notifyParty:'SAME AS CONSGINEE',
    instructionTo:'HMM',
    goodsDescription:'C/T BOXES OF USED HOUSEHOLD GOODS & PERSONAL EFFECTS',
    hsCode:'94039090',
    terms:'CY/CY',
    exportFefNo:'',
    loadingPlan:[],
    placeOfDelivery:'',
    issuer:'Danny',
    blAddiontalPackages:'',
    masterBill:'',
    documents:[],
    carrierAgentName:'UKO SHIPPING LTD',
    carrierAgentAddress:'TEL: +44 01420 430 750',
    ahc:0,
    ahcFloat:0.00,
    fsc:0,
    fscFloat:0.00,
    moc:0,
    mocFloat:0.00,
    avs:0,
    avsFloat:0.00,
    iataCode:'',
    accountNumber:'',
    reference:'',

  };
  return item;
}



// WEBPACK FOOTER //
// ./src/api/manifests.js